(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            {
                domain: require('./domain.js'),
                facebook: require('./facebook.js'),
                instagram: require('./instagram.js'),
                linkedin: require('./linkedin.js'),
                tiktok: require('./tiktok.js'),
                twitter: require('./twitter.js'),
                youtube: require('./youtube.js')
            },
            undefined,
            require('../enums/colors.js'),
            require('../enums/metrics.js'),
            require('../strings/strings.js'),
            require('../str.js'),
            require('../modules/metric/metric.js'),
            require('../modules/utils/metric.js'),
            require('../modules/utils/sort.js'),
            require('../enums/postTypes.js'),
            require('../modules/formatter.js'),
            require('../../lib/riq-moment.js'),
            require('lodash'),
            require('underscore.string'),
            require('../modules/utils/timezone.js'),
            require('../modules/data/channels.js')
        );

    } else {
        RivalIQ.module('metrics', function () { });
        RivalIQ.metrics.definitions = {};
        RivalIQ.metrics.definitions.crossChannel = exportFn(
            RivalIQ.metrics.definitions,
            RivalIQ.views.metric,
            RivalIQ.enums.colors,
            RivalIQ.enums,
            RivalIQ.strings,
            RivalIQ,
            RivalIQ.metric,
            RivalIQ.utils.metric,
            RivalIQ.utils.sort,
            RivalIQ.enums.postTypes,
            RivalIQ.formatter,
            window.moment,
            window._,
            window.s,
            RivalIQ.utils.timezone,
            RivalIQ.data.channels
        );
    }

    function exportFn(channelOverrides, views, colors, metricEnums, strings, str, metricFn, utils, sort, postTypes, formatter, moment, _, s, timezoneUtils, channels) {

        function valueByDimension(dimension, a, b) {
            return function (val, metric) {
                if (_.includes(metric.dimensions, dimension)) {
                    return a;
                }
                return b;
            };
        }

        const companyIdFormatter = function (companyId, metric, options) {
            if (options && options.companies) {
                if (_.isFunction(options.companies)) {
                    return options.companies(Number(companyId));
                }

                return _.find(options.companies, {
                    id: Number(companyId)
                }).name;
            }

            const company = RivalIQ.state.landscape.get('companies').findWhere({
                id: Number(companyId)
            });
            const companyName = (company ? company.get('name') : '');
            return companyName;
        };

        const companyIdMapping = {
            name: 'Company',
            format: companyIdFormatter,
            csvFormat: companyIdFormatter,
            color: function (value) {
                return (RivalIQ.state.utils.getFocusedCompanyId() === Number(value) ? colors.focus : colors.competitor);
            },
            cellView: function () {
                return RivalIQ.views.metric.CompanyRank;
            },
            mustInclude: function (data, metric) {
                return Number(_.head(data)) === metric.focusCompanyId;
            },
            sort: function () {
                return sort.company;
            }
        };

        const companySetIdFormatter = function (companySetId, metric, options) {
            if (options && options.companySets) {
                return _.find(options.companySets, {
                    id: _.first(companySetId)
                }).name;
            }

            return RivalIQ.state.companySets.get(_.first(companySetId)).get('name');
        };

        const timeAnalysisModes = {};
        timeAnalysisModes[metricEnums.timeAnalysisMode.MAIN_PERIOD] = {
            format: 'Current',
            csvFormat: 'Current',
            clarificationName: '',
            name: 'Current Period Values',
            description: strings.time_analysis_mode_current_period_values_description
        };
        timeAnalysisModes[metricEnums.timeAnalysisMode.COMPARE_PERIOD] = {
            format: 'Previous',
            csvFormat: 'Previous',
            clarificationName: 'Previous Period',
            name: 'Previous Period Values',
            description: strings.time_analysis_mode_previous_period_values_description
        };
        timeAnalysisModes[metricEnums.timeAnalysisMode.DELTA_ABSOLUTE] = {
            format: 'Abs. Change',
            csvFormat: 'Abs. Change',
            clarificationName: 'Change',
            name: 'Change',
            description: strings.time_analysis_mode_change_description
        };
        timeAnalysisModes[metricEnums.timeAnalysisMode.DELTA_RELATIVE] = {
            format: '% Change',
            csvFormat: '% Change',
            clarificationName: '% Change',
            name: 'Percentage Change',
            description: strings.time_analysis_mode_percentage_change_description
        };
        timeAnalysisModes[metricEnums.timeAnalysisMode.DAILY_VALUES] = {
            format: 'Daily Values',
            clarificationName: '',
            name: 'Daily Values',
            description: strings.time_analysis_mode_daily_values_description
        };

        function engagementRateMetric(overrides) {
            return _.extend({
                name: 'Engagement Rate by Follower',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: strings.cross_channel_avg_engagement_rate_per_post_description,
                cellView: function (data, metric) {
                    return (data[0] !== '__SUMMARY_ROW__' && metric.isNotRelative(data) ? views.Bar : undefined);
                },
                category: 'post_analysis',
                metricCategory: metricEnums.category.ENGAGEMENT,
                collection: metricEnums.collection.ENGAGEMENT
            }, overrides);
        }

        function formatPostTagId(postTagId, metric, options) {

            if (postTagId === '__SUMMARY_ROW__') {
                const postWord = channels.get(metric.channel).get('postName');
                return `All ${_.capitalize(postWord)}s`;
            }

            if (options) {
                const postTagNames = _.map(postTagId.split(','), function (tagId) {
                    const postTag = _.find(options.postTags, {
                        id: Number(_.trim(tagId))
                    });
                    return _.get(postTag, ['tag_name'], tagId);
                });

                postTagNames.sort(function (a, b) {
                    return a.localeCompare(b);
                });

                return postTagNames.join(', ');
            }

            return postTagId;
        }

        return {
            name: 'Cross-Channel',
            avg_count_per_day: {
                name: 'Posts / Day',
                description: strings.cross_channel_average_daily_posts_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                type: metricEnums.dataType.NUMERIC,
                metricCategory: metricEnums.category.ACTIVITY,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            avg_count_per_week: {
                name: 'Posts / Week',
                description: strings.cross_channel_avg_count_per_week_description,
                type: metricEnums.dataType.NUMERIC,
                metricCategory: metricEnums.category.ACTIVITY,
                collection: metricEnums.collection.ACTIVITY,
                defaultTimeSeriesInterval: 'week',
                summable: false
            },
            avg_count_landscape: {
                name: 'Avg. Posts, Landscape',
                type: metricEnums.dataType.NUMERIC
            },
            posts_per_week: {
                format: function (val) {
                    if (_.isArray(val)) {
                        val = _.last(val);
                    }
                    return formatter.formats.fixed(val);
                },
                defaultTimeSeriesInterval: 'week',
                summable: false
            },
            avg_engagement_total_per_day: {
                name: 'Engagement Total / Day',
                description: strings.cross_channel_average_daily_posts_engagement_total_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                type: metricEnums.dataType.NUMERIC,
                metricCategory: metricEnums.category.ENGAGEMENT,
                collection: metricEnums.collection.ENGAGEMENT,
                summable: false
            },
            followers_to_following: {
                name: 'Followers / Following Ratio',
                metricType: metricEnums.metricType.TOTAL,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true,
                summable: false
            },
            avg_engagement_rate_per_day: {
                name: 'Engagement Rate / Day',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                metricCategory: metricEnums.category.ENGAGEMENT,
                collection: metricEnums.collection.ENGAGEMENT
            },
            avg_links_per_domain: {
                type: metricEnums.dataType.NUMERIC,
                metricValueType: metricEnums.metricValueType.AVERAGE
            },
            source: {
                name: 'Channel',
                format: function (data, metric) {
                    const value = (_.isArray(data) ? _.last(data) : data);

                    return metricEnums.sourceDetails[value].name;
                },
                csvFormat: function (data, metric) {
                    const value = (_.isArray(data) ? _.last(data) : data);

                    return metricEnums.sourceDetails[value].name;
                }
            },
            presence_handle: {
                name: 'Presence Handle',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.STRING,
                description: strings.presence_handle_description
            },
            icon_url: {
                name: 'Icon',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.STRING,
                cellView: function () {
                    return RivalIQ.views.metric.PresenceIcon;
                }
            },
            engagement_rate: {
                name: 'Engagement Rate by Follower',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                description: strings.cross_channel_engagement_rate_description,
                axisFormat: function (value, metric, options) {
                    return `${formatter.formatAbbreviated(value * 100, undefined, options)}%`;
                },
                category: 'post_analysis',
                metricCategory: metricEnums.category.ENGAGEMENT,
                collection: metricEnums.collection.ENGAGEMENT
            },
            'engagement_total / presence_reach': {
                type: metricEnums.dataType.ABSOLUTE_PERCENT
            },
            'engagement_total_likely_boosted / presence_reach_likely_boosted': {
                type: metricEnums.dataType.ABSOLUTE_PERCENT
            },
            'engagement_total_non_boosted / presence_reach_non_boosted': {
                type: metricEnums.dataType.ABSOLUTE_PERCENT
            },
            overview: {
                name: 'Description',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.TEXT,
                missingDataFormat: function (data, metric) {
                    return (metric.isMainPeriod(data) && !_.includes(metric.dimensions, 'companySetId') ? metricEnums.strings.NOT_ON_CHANNEL : metricEnums.strings.MISSING);
                },
                emptyStringFormat: metricEnums.strings.EMPTY_TEXT
            },
            about: {
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.TEXT,
                emptyStringFormat: metricEnums.strings.EMPTY_TEXT
            },
            title_size: {
                hasHistory: false
            },
            overview_size: {
                name: 'Description Length',
                hasHistory: false,
                description: strings.overview_size_desc
            },
            display_name: {
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.STRING
            },
            display_name_size: {
                name: 'Display Name Length',
                hasHistory: false
            },
            avg_engagement_rate_per_post: engagementRateMetric(),
            avg_engagement_rate_per_post_day: {
                name: 'Average Engagement Rate',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: strings.cross_channel_avg_engagement_rate_per_post_description
            },
            avg_engagement_rate_per_boosted_post: engagementRateMetric({
                cellView: undefined,
                name: 'Engagement Rate, Likely Boosted'
            }),
            avg_engagement_rate_per_non_boosted_post: engagementRateMetric({
                cellView: undefined,
                name: 'Engagement Rate, Likely Organic'
            }),
            avg_engagement_rate_per_post_in_period: engagementRateMetric(),
            avg_engagement_rate_per_post_owned: engagementRateMetric({
                name: function (val, metric) {
                    const audienceName = metric.channel === 'facebook' ? 'Page Fan' : 'Follower';
                    return `Owned Eng. Rate by ${audienceName}`;
                },
                description: function (val, metric) {
                    const audienceName = metric.channel === 'facebook' ? 'page fan' : 'follower';
                    return RivalIQ.str('average_owned_link_engagement_rate_description', audienceName);
                },
                cellView: _.constant() // don't show bars in the table cells for these metrics
            }),
            avg_engagement_rate_per_post_curated: engagementRateMetric({
                name: function (val, metric) {
                    const audienceName = metric.channel === 'facebook' ? 'Page Fan' : 'Follower';
                    return `Curated Eng. Rate by ${audienceName}`;
                },
                description: function (val, metric) {
                    const audienceName = metric.channel === 'facebook' ? 'page fan' : 'follower';
                    return RivalIQ.str('average_curated_link_engagement_rate_description', audienceName);
                },
                cellView: _.constant() // don't show bars in the table cells for these metrics
            }),
            engagement_rate_by_view: engagementRateMetric({
                name: 'Engagement Rate by View',
                cellView: _.constant(), // don't show bars in the table cells for these metrics
                summable: false
            }),
            'engagement_total / views': {
                type: metricEnums.dataType.ABSOLUTE_PERCENT
            },
            engagement_total: {
                name: 'Engagement Total',
                description: function (val, metric) {
                    if (_.last(metric.dimensions) === 'post') {
                        return strings.single_channel_engagement_description;
                    }
                    return strings.cross_channel_engagement_description;
                },
                category: 'post_analysis',
                metricCategory: metricEnums.category.ENGAGEMENT,
                collection: metricEnums.collection.ENGAGEMENT
            },
            'engagement_total / count': {
                name: 'Engagement Total / Post',
                metricValueType: metricEnums.metricValueType.AVERAGE,
                type: metricEnums.dataType.NUMERIC
            },
            engagement_total_per_post: {
                name: 'Engagement Total / Post',
                type: metricEnums.dataType.NUMERIC,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                description: strings.engagement_total_per_post_description,
                metricCategory: metricEnums.category.ENGAGEMENT,
                collection: metricEnums.collection.ENGAGEMENT,
                summable: false
            },
            companySetId: {
                name: 'Company Set',
                description: strings.favorites_builder_companySetId_dimension_description,
                format: companySetIdFormatter,
                csvFormat: companySetIdFormatter,
                cellView: function () {
                    return RivalIQ.views.metric.CompanySetRank;
                }
            },
            companies_using: {
                name: function (value, metric) {
                    if (_.last(metric.dimensions) === 'keyword') {
                        return 'Companies Posting';
                    }

                    return 'Companies Using';
                },
                description: function (val, metric) {
                    const freeDimension = _.head(metricFn.getFreeDimensions(metric));
                    const name = metricFn.names.dimensionName(freeDimension);
                    return str.str('companies_using_description', s.decapitalize(name));
                },
                cellView: function () {
                    return views.CompanyCountCell;
                }
            },
            other_posts_engagement_rate_by_presence_reach: engagementRateMetric({
                name: function (val, metric) {
                    const audienceName = metric.channel === 'facebook' ? 'Page Fan' : 'Follower';

                    return `Engagement Rate by ${audienceName} w/o tag`;
                },
                description: function (val, metric) {
                    const audienceName = metric.channel === 'facebook' ? 'page fans' : 'followers';
                    return `The total engagements divided by number of ${audienceName} for post without the associated tag.`;
                },
                cellView: function () {
                    return views.OtherPostsEngagementCell;
                }
            }),
            engagement_rate_by_presence_reach_lift: {
                name: 'Engagement Rate Lift',
                description: function (val, metric) {

                    let postWord;
                    if (metric.channel === 'twitter') {
                        postWord = 'tweet';
                    } else if (metric.channel === 'tiktok') {
                        postWord = 'video';
                    } else {
                        postWord = 'post';
                    }

                    const audienceName = metric.channel === 'facebook' ? 'Page Fan' : 'Follower';

                    if (_.includes(metric.dimensions, 'post')) {
                        return `The Engagement Rate by ${audienceName} lift shows how many times better or worse this ${postWord} did compared to the average of the other ${postWord}s that match this query.`;
                    } else if (_.includes(metric.dimensions, 'post_tag_id')) {
                        return `The Engagement Rate by ${audienceName} lift shows how many times better or worse the tagged ${postWord}s did compared to ${postWord}s without that tag.`;
                    } else if (_.includes(metric.dimensions, 'hashtag')) {
                        return `The Engagement Rate by ${audienceName} lift shows how many times better or worse the ${postWord}s with the hashtag did compared to ${postWord}s without that hashtag.`;
                    } else if (_.includes(metric.dimensions, 'keyword')) {
                        return `The Engagement Rate by ${audienceName} lift shows how many times better or worse ${postWord}s on this topic did compared to the other ${postWord}s.`;
                    }
                },
                type: metricEnums.dataType.NUMERIC,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                cellView: function () {
                    return views.EngagementLiftCell;
                },
                category: 'post_analysis',
                metricCategory: metricEnums.category.ENGAGEMENT,
                collection: metricEnums.collection.ENGAGEMENT
            },
            people_using: {
                property: 'people_using',
                name: 'People Using',
                cellView: function () {
                    return views.PeopleUsingCountCell;
                }
            },
            posts_per_hour: {
                name: 'Posts per hour'
            },
            num_posts: {
                name: 'Number of Posts'
            },
            median_user_followers: {
                name: 'Median Followers',
                noHistoricData: true
            },
            influencer_score: {
                name: 'Potential Influence',
                description: strings.discovery_influencer_score_description,
                csvFormat: function (data) {
                    const segmentCount = 4;
                    const influencerScore = (_.isArray(data) ? _.last(data) : data);
                    return Math.min(segmentCount, Math.ceil(influencerScore * (segmentCount - 1)));
                }
            },
            'count / companyId.count': {
                name: 'Avg. Posts / Company',
                type: metricEnums.dataType.NUMERIC
            },
            'count / period': {
                name: 'Posts / Day',
                description: strings.cross_channel_count_per_period_description,
                type: metricEnums.dataType.NUMERIC
            },
            'total_impressions / period': {
                name: 'Impressions / Day',
                description: strings.cross_channel_impressions_per_period_description,
                type: metricEnums.dataType.NUMERIC
            },
            'total_impressions / count': {
                name: 'Impressions / Post',
                description: strings.cross_channel_impressions_per_count_description,
                type: metricEnums.dataType.NUMERIC
            },
            'avg_activity_per_period': {
                // NOTE for context on naming see #15926, #16547
                name: 'Average Daily Posts',
                type: metricEnums.dataType.NUMERIC
            },
            'with_hashtags / count': {
                name: 'Posts with Hashtags',
                type: metricEnums.dataType.NUMERIC
            },
            shared_url_count_distinct: {
                name: 'Unique URLs',
                description: strings.shared_url_count_distinct_description,
                type: metricEnums.dataType.INTEGER
            },
            shared_url_count_distinct_owned: {
                name: 'Owned URLs',
                description: strings.shared_url_count_distinct_owned_description
            },
            shared_url_count_distinct_curated: {
                name: 'Curated URLs',
                description: strings.shared_url_count_distinct_curated_description
            },
            shared_url_pct_curated: {
                name: '% Curated URLs',
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                description: strings.shared_url_pct_curated_description
            },
            avg_shared_urls: {
                name: 'Avg. Posts / URL',
                description: strings.avg_shared_urls_description,
                type: metricEnums.dataType.NUMERIC
            },
            'count / period / companyId.count': {
                type: metricEnums.dataType.NUMERIC
            },
            published_at: {
                name: 'Published At',
                type: metricEnums.dataType.DATE,
                format: function (data) {
                    const val = (_.isArray(data) ? _.last(data) : data);
                    return formatter.formats.date(val);
                },
                csvFormat: function (data, metric, options) {
                    const val = (_.isArray(data) ? _.last(data) : data);

                    let timezone = 'UTC';
                    if (options) {
                        timezone = _.get(options, ['landscape', 'timezone']) || 'UTC';
                    }

                    return timezoneUtils.getDateInTimezone(timezone, val);
                }
            },
            captured_at: {
                name: 'Captured At',
                type: metricEnums.dataType.DATE,
                format: function (data) {
                    const val = (_.isArray(data) ? _.last(data) : data);
                    return formatter.formats.date(val);
                },
                csvFormat: function (data, metric, options) {
                    const val = (_.isArray(data) ? _.last(data) : data);

                    let timezone = 'UTC';
                    if (options) {
                        timezone = _.get(options, ['landscape', 'timezone']) || 'UTC';
                    }

                    return timezoneUtils.getDateInTimezone(timezone, val);
                }
            },
            period: {
                name: function () {
                    return 'Day'; // TODO make more general
                }
            },
            with_hashtags: {
                name: 'Hashtags'
            },
            count: {
                name: function (value, metric) {
                    if (_.isEmpty(_.get(metric, 'over'))) {
                        if (metric.key === 'SOCIAL_POSTS_HASHTAGS') {
                            return 'Posts Using';
                        }
                    }

                    return 'Posts';
                },
                description: strings.cross_channel_activity_description,
                metricCategory: metricEnums.category.ACTIVITY,
                collection: metricEnums.collection.ACTIVITY
            },
            type: {
                name: 'Post Type',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.STRING,
                description: strings.post_type_description,
                value: postTypes
            },
            mediaType: {
                name: 'Type',
                format: function (data) {
                    return (_.isArray(data) ? _.last(data) : data);
                }
            },
            channel: {
                name: 'Post Channel',
                clarificationName: 'Cross-Channel',
                value: channelOverrides,
                dimensionValues: function (value, metric) {
                    // Omit hidden channels
                    return RivalIQ.props.getChannels(metric).pluck('channel');
                }
            },
            companyId: companyIdMapping,
            company_id: companyIdMapping,
            presence_id: {
                cellView: function () {
                    return RivalIQ.views.metric.PresenceRank;
                }
            },
            canonicalUrl: {
                name: 'Posted URL',
                cellView: function () {
                    return RivalIQ.apps.SocialPosts.widgets.SharedDomainCell;
                },
                format: function (data) {
                    return (_.isArray(data) ? _.last(data) : data);
                },
                color: colors.competitor
            },
            primaryDomain: {
                name: 'Posted Domain',
                format: function (data) {
                    return (_.isArray(data) ? _.last(data) : data);
                },
                color: colors.competitor
            },
            postedTitle: {
                name: 'Posted Title'
            },
            hashtag: {
                name: 'Hashtag',
                format: function (data) {
                    const hashtag = (_.isArray(data) ? _.last(data) : data);
                    if (hashtag === '__SUMMARY_ROW__') {
                        return 'All Posts';
                    }
                    return `#${hashtag}`;
                },
                csvFormat: function (data) {
                    const hashtag = (_.isArray(data) ? _.last(data) : data);
                    return `#${hashtag}`;
                },
                cellView: function () {
                    return RivalIQ.apps.SocialPosts.views.HashtagNameCell;
                },
                color: colors.competitor
            },
            keyword: {
                name: 'Topic',
                type: metricEnums.dataType.STRING,
                format: function (data) {
                    const keyword = (_.isArray(data) ? _.last(data) : data);

                    if (keyword === '__SUMMARY_ROW__') {
                        return 'All Posts';
                    }

                    return keyword;
                }
            },
            posts_about: {
                name: function (value, metric) {
                    if (metric.channel === 'linkedin') {
                        return 'Updates';
                    } else if (metric.channel === 'twitter') {
                        return 'Tweets';
                    } else if (metric.channel === 'tiktok') {
                        return 'Videos';
                    } else {
                        return 'Posts';
                    }
                },
                description: strings.keyword_count_description
            },
            post_tag_ids: {
                name: 'Post Tag',
                color: colors.competitor,
                csvFormat: function (postTagId, metric, options) {
                    return formatPostTagId(postTagId, metric, options);
                }
            },
            post_tag_id: {
                name: 'Post Tag',
                color: colors.competitor,
                csvFormat: function (postTagId, metric, options) {
                    return formatPostTagId(postTagId, metric, options);
                }
            },
            hour: {
                format: function (data) {
                    const hour = (_.isArray(data) ? _.last(data) : data);
                    return moment().hour(hour).format('ha');
                },
                // NOTE graphs should go 12am to 11pm, not 12am to 12am
                domainRange: function () {
                    return [0, 24];
                }
            },
            day: {
                name: 'Day',
                format: function (data, metric, options) {
                    let day = (_.isArray(data) ? _.last(data) : data);
                    day = moment.utc(metric.getDataTimePeriod().mainPeriodStart).add(day, 'days');

                    if (_.get(options, 'expand', false)) {
                        return day.format('MMM D, YYYY');
                    } else {
                        return day.format('L');
                    }
                },
                csvFormat: function (data, metric) {
                    let day = (_.isArray(data) ? _.last(data) : data);
                    day = moment.utc(metric.getDataTimePeriod().mainPeriodStart).add(day, 'days');
                    return moment.utc(day).format('YYYY-MM-DD');
                }
            },
            storyDay: {
                name: 'storyDay',
                format: function (data, metric, options) {
                    let day = (_.isArray(data) ? _.last(data) : data);
                    day = moment.utc(metric.getDataTimePeriod().mainPeriodStart).add(day, 'days');

                    if (_.get(options, 'expand', false)) {
                        return day.format('MMM D, YYYY');
                    } else {
                        return day.format('L');
                    }
                },
                csvFormat: function (data, metric) {
                    let day = (_.isArray(data) ? _.last(data) : data);
                    day = moment.utc(metric.getDataTimePeriod().mainPeriodStart).add(day, 'days');
                    return moment.utc(day).format('YYYY-MM-DD');
                }
            },
            postDay: {
                name: 'postDay',
                format: function (data, metric, options) {
                    let day = (_.isArray(data) ? _.last(data) : data);
                    day = moment.utc(metric.getDataTimePeriod().mainPeriodStart).add(day, 'days');

                    if (_.get(options, 'expand', false)) {
                        return day.format('MMM D, YYYY');
                    } else {
                        return day.format('L');
                    }
                },
                csvFormat: function (data, metric) {
                    let day = (_.isArray(data) ? _.last(data) : data);
                    day = moment.utc(metric.getDataTimePeriod().mainPeriodStart).add(day, 'days');
                    return moment.utc(day).format('YYYY-MM-DD');
                }
            },
            week: {
                name: function (value, metric, options) {
                    return (_.get(options, ['format']) === 'csv' ? 'Week Start Date' : 'Week');
                },
                format: function (data, metric) {
                    let week = (_.isArray(data) ? _.last(data) : data);
                    week = moment.utc(metric.getDataTimePeriod().mainPeriodStart).startOf('week').add(week, 'weeks');
                    return week.format('L');
                },
                csvFormat: function (data, metric) {
                    let week = (_.isArray(data) ? _.last(data) : data);
                    week = moment.utc(metric.getDataTimePeriod().mainPeriodStart).startOf('week').add(week, 'weeks');
                    return moment.utc(week).format('YYYY-MM-DD');
                }
            },
            month: {
                name: function (value, metric, options) {
                    return (_.get(options, ['format']) === 'csv' ? 'Month Start Date' : 'Month');
                },
                format: function (data, metric) {
                    let month = (_.isArray(data) ? _.last(data) : data);
                    month = moment.utc(metric.getDataTimePeriod().mainPeriodStart).startOf('month').add(month, 'months');
                    return month.format('L');
                },
                csvFormat: function (data, metric) {
                    let month = (_.isArray(data) ? _.last(data) : data);
                    month = moment.utc(metric.getDataTimePeriod().mainPeriodStart).startOf('month').add(month, 'months');
                    return moment.utc(month).format('YYYY-MM-DD');
                }
            },
            timeAnalysisMode: {
                name: 'Time Analysis Mode',
                value: timeAnalysisModes
            },
            dayOfWeek: {
                name: 'Day of Week',
                format: function (data, metric, options) {
                    const day = (_.isArray(data) ? _.last(data) : data);
                    const format = (_.get(options, 'expand') ? 'dddd' : 'ddd');
                    return moment().day(day).format(format);
                },

                domainRange: function () {
                    return [0, 7];
                }
            },
            audience: {
                name: 'Audience',
                description: strings.cross_channel_audience_description,
                metricType: metricEnums.metricType.TOTAL,
                category: 'post_analysis',
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            presence_reach: {
                name: 'Audience',
                description: strings.cross_channel_audience_description,
                metricType: metricEnums.metricType.TOTAL,
                category: 'post_analysis',
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            all_presence_reach: {
                metricType: metricEnums.metricType.TOTAL,
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            potential_reach: {
                name: 'Potential Reach',
                description: strings.cross_channel_potential_reach_description,
                noHistoricData: true
            },
            postLink: {
                name: 'Post Link'
            },
            linkTitle: {
                name: 'Link Title'
            },
            linkDescription: {
                name: 'Link Description'
            },
            lifetime_count: {
                metricType: metricEnums.metricType.TOTAL,
                metricCategory: metricEnums.category.ACTIVITY
            },
            following: {
                name: 'Following',
                metricType: metricEnums.metricType.TOTAL,
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            title: {
                name: 'Title',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.TEXT,
                emptyStringFormat: metricEnums.strings.EMPTY_TEXT
            },
            keywords: {
                name: 'Keywords',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.TEXT,
                emptyStringFormat: metricEnums.strings.EMPTY_TEXT
            },
            views: {
                name: 'Video Views',
                category: 'post_analysis', // this makes this metric show up in the post modal.
                description: strings.cross_channel_video_views_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            video_views: {
                name: 'Video Views',
                category: 'post_analysis',
                description: strings.cross_channel_video_views_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            video_views_per_day: {
                name: 'Video Views / Day',
                description: strings.cross_channel_video_views_per_day_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                type: metricEnums.dataType.NUMERIC
            },
            video_views_per_post: {
                name: 'Video Views / Post',
                description: strings.cross_channel_views_per_post_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                type: metricEnums.dataType.NUMERIC
            },
            engagement_type: {
                // This defines the order these will appear in bar charts.
                dimensionValues: _.constant(['applause', 'conversation', 'amplification']),

                value: {
                    applause: {
                        format: 'Applause',
                        className: 'twitter',

                        engagement_total: {
                            name: 'Applause',
                            description: strings.cross_channel_applause_description,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        },
                        avg_engagement_total_per_day: {
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        }
                    },
                    amplification: {
                        format: 'Amplification',
                        engagement_total: {
                            name: 'Amplification',
                            description: strings.cross_channel_amplification_description,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        },
                        avg_engagement_total_per_day: {
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        }
                    },
                    conversation: {
                        format: 'Conversation',
                        engagement_total: {
                            name: 'Conversation',
                            description: strings.cross_channel_conversation_description,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        },
                        avg_engagement_total_per_day: {
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        }
                    }
                }
            },
            message: {
                name: 'Message'
            },
            image: {
                name: 'Image'
            },
            link: {
                name: 'Link'
            },
            likely_promoted: {
                name: 'Likely Boosted Posts',
                requiredPlanFeature: 'has_likely_promoted',
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            pct_of_overall: {
                type: metricEnums.dataType.ABSOLUTE_PERCENT
            },
            post: {
                name: function (value, metric, options) {
                    return (_.get(options, ['format']) === 'csv' ? 'Post Id' : 'Post');
                },
                csvFormat: _.identity
            },
            story: {
                name: function (value, metric, options) {
                    return (_.get(options, ['format']) === 'csv' ? 'Story Id' : 'Story');
                },
                csvFormat: _.identity
            },
            estimated_impressions: {
                name: 'Estimated Impressions',
                requiredPlanFeature: 'has_estimated_impressions',
                collection: metricEnums.collection.GENERAL,
                category: 'post_analysis', // this makes this metric show up in the post modal
                description: valueByDimension('post', strings.post_estimated_impressions_description, strings.estimated_impressions_description)
            },
            engagement_rate_by_estimated_impression: {
                name: 'Engagement Rate by Estimated Impression',
                requiredPlanFeature: 'has_estimated_impressions',
                collection: metricEnums.collection.ENGAGEMENT,
                category: 'post_analysis', // this makes this metric show up in the post modal
                description: valueByDimension('post', strings.post_engagement_rate_by_estimated_impression_description, strings.engagement_rate_by_estimated_impression_description),
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                metricValueType: metricEnums.metricValueType.AVERAGE
            }
        };
    }
})();
